import buildSubjectListPath from '@UI/Pages/Beneficiaries/Shared/Helpers/buildSubjectListPath';
import useSubjectAddressParams from '@UI/Pages/Beneficiaries/Hooks/Params/useSubjectAddressParams';
import DocumentsNotifications from '@UI/Pages/Beneficiaries/BeneficiaryDetails/Pages/Documents/DocumentsNotifications';
import InterviewsNotifications from '@UI/Pages/Beneficiaries/BeneficiaryDetails/Pages/Interviews/InterviewsNotifications';
import SubjectBreadcrumb from '@UI/Pages/Beneficiaries/Shared/SubjectBreadcrumb';
import SubjectDetailsContent from '@UI/Pages/Subjects/SubjectDetails/SubjectDetailsContent';
import SubjectsNotifications from '@UI/Pages/Subjects/SubjectsNotifications';
import useSubjectTypes from '@UI/Hooks/useSubjectTypes';
import SubjectScreenContainer from '@UI/Pages/Beneficiaries/Shared/SubjectScreen/SubjectScreenContainer';
import * as React from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import ConditionalLoader from '@Guidelines/Component/Loader/ConditionalLoader';

/**
 * Assembles the screen: breadcrumb, the data-owning `SubjectDetailsContent` and notifications.
 * Redirects to the list of the type when the route's `subject` segment is not a valid id, and only
 * mounts the content once the address is valid and its type is known.
 */
const SubjectDetails: React.FC = () => {
	const navigate = useNavigate();
	const { subjectType: typeKey = '' } = useParams<{ subjectType: string }>();
	const { subject } = useSubjectAddressParams();
	const { types } = useSubjectTypes();
	const type = types?.findByKey(typeKey) ?? null;

	React.useEffect(() => {
		if (subject === null) {
			navigate(buildSubjectListPath(typeKey));
		}
	}, [subject, typeKey, navigate]);

	return (
		<SubjectScreenContainer>
			<ConditionalLoader data={subject !== null && type !== null ? { subject, type } : null}>
				{(resolved) => (
					<React.Fragment>
						<SubjectBreadcrumb subject={resolved.subject} />
						<SubjectDetailsContent subject={resolved.subject} type={resolved.type} />
					</React.Fragment>
				)}
			</ConditionalLoader>

			<SubjectsNotifications />
			<InterviewsNotifications />
			<DocumentsNotifications />
		</SubjectScreenContainer>
	);
};

export default SubjectDetails;
